export default "__VITE_ASSET__dd65a926__"